<template>
    <section id="reviews-slider" class="pb-12 lg:pb-12 pt-10 lg:pt-16" v-show="isTrustpilotWidgetEnabled">
        <div class="max-w-screen-xl mx-auto px-5 lg:flex lg:flex-col lg:items-center">
            <h2 class="text-3xl lg:text-5xl font-division-heading font-semibold lg:max-w-xl lg:text-center">Real Client Reviews</h2>
        </div>
        <!-- TrustBox widget - Slider -->
        <div id="reviews-slider-widget" class="max-w-screen-xl mt-8 lg:mt-10 mx-auto px-3 trustpilot-widget" data-locale="en-US"
            data-template-id="54ad5defc6454f065c28af8b" data-businessunit-id="583140ae0000ff000597c764"
            data-style-height="240px" data-stars="4,5" data-style-width="100%" data-review-languages="en">
        </div>
        <!-- End TrustBox widget -->
    </section>
</template>

<script>
import ObserverMixin from '../../mixins/trustpilot-observer';

export default {
    mixins: [ObserverMixin],

    mounted() {
        let vm = this;
        this.$nextTick(() => { vm.isTrustpilotWidgetEnabled = window.isTrustpilotWidgetEnabled; });

        this.initiObserver('reviews-slider-widget');
    },
}
</script>
